// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1d72704d","66":"797a8fd2","218":"87efdeb7","263":"b8c12af3","378":"cdce1858","397":"43c7cc2a","427":"c52bb238","511":"5dc73a6a","644":"2978d5af","655":"09972189","695":"d5598049","731":"7b025c09","876":"170ea7f8","955":"4a46faa7","969":"7848c00a","975":"2059d058"}[chunkId] + ".chunk.js";
};